import React from 'react';

import DateFnsUtils from '@date-io/date-fns';

import Button        from '@material-ui/core/Button';
import Dialog        from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle   from '@material-ui/core/DialogTitle';

import { KeyboardDatePicker }  from '@material-ui/pickers';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import { create } from '../util';

export default function NewBirthdate(props) {
  return (
    <Dialog open={props.newBirthdate.rowid > -1}>
      <DialogTitle>
        {'생년월일'}
      </DialogTitle>
      <DialogContent>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker format="yyyy/MM/dd"
            onChange={(datetime) => {
              props.setNewBirthdate((_birthdate) => ({
                ..._birthdate, birthdate: datetime.getTime(),
              }));
            }}
            value={new Date(props.newBirthdate.birthdate)}
          />
        </MuiPickersUtilsProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={(event) => {
          props.setNewBirthdate(create.birthdate());
        }}>{'취소'}</Button>
        <Button color="primary" onClick={(event) => {
          props.updateAttender(props.newBirthdate, () => {
            props.setNewBirthdate(create.birthdate());
          });
        }}>{'확인'}</Button>
      </DialogActions>
    </Dialog>
  );
}